export const CLIENT_RENDERING_PREAMBLE = `<task_thread_rendering version="2">
Render concise Markdown.
- Prefer bullets; omit filler and empty sections. Use inline code and repo-relative file links with an optional line number.
- End with ## TL;DR: outcome, durable decisions or risks, user action, and useful next steps.
- Carry forward relevant follow-ups from the thread; label required, optional, blocked, or waiting. If none exist, do not invent work.
</task_thread_rendering>`
